import styled from "styled-components";
import { Button } from "@viagogo/core/ui";

// ––– Banner –––

export const BannerContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing(6)};
  border-radius: ${({ theme }) => theme.borderRadius.m};
  border-color: ${({ theme }) => theme.palette.borderNeutralSecondary};
  border-width: 1px;
  border-style: solid;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(5)};

  @media ${({ theme: { media } }) => media.phone} {
    flex-direction: column;
  }
`;

export const BannerTitle = styled.p`
  flex: 1;
  color: ${({ theme }) => theme.palette.textPrimaryOnSurface};
  ${({ theme }) => theme.typography.getStyles(theme.typography.variant.headerMedium)}

  @media ${({ theme: { media } }) => media.phone} {
    text-align: center;
  }
`;

export const EmailOptInButton = styled(Button)`
  @media ${({ theme: { media } }) => media.phone} {
    padding: ${({ theme }) => theme.spacing(3.5, 16)};
  }
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    padding: ${({ theme }) => theme.spacing(3, 8)};
  }
`;

export const EmailOptInButtonTitle = styled.p`
  ${({ theme }) => theme.typography.getStyles(theme.typography.variant.labelSmall)};
`;

// ––– Content View –––

export const ContentViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(2, 0, 4, 0)};
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const ContentViewTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const SubscribeButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(4, 0, 2, 0)};
`;

export const SubscribeButton = styled(Button)`
  width: 100%;
`;
